<template>
  <div id="container__dropDown-observer" class="position-relative w-100">
    <button class="js-dropDown base__dropdown-button btn--outline-none">
      <p
        _filter_drop_down
        :_default_value="placeholder"
        class="m-0 p-0 text__overflow--ellipsis"
      >
        {{ placeholder }}
      </p>
    </button>
    <div class="drop-down__results js-dropDownResults custom__scroll-bar">
      <ul>
        <li
          class="drop-down__results-item"
          v-for="(item, i) in items"
          :key="i"
          @click.prevent="selectItem(item)"
        >
          {{ item.name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterSelect',
  props: {
    placeholder: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
  },
  setup(_, context) {
    function selectItem(item) {
      context.emit('itemSelected', item)
    }

    return { selectItem }
  },
}
</script>
